const TabButton = ({ children, isActive = false, onClick }) => {
  return (
    <button
      className={`min-w-13 w-full py-1.5 rounded-lg text-xs font-medium cursor-pointer
        ${
          isActive
            ? "bg-white text-gray-900 shadow-sm border border-gray-200"
            : "text-gray-400 hover:text-gray-800"
        }`}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default TabButton
